'use strict';

module.exports = {
  name: 'Default',
  refresh: function refresh() {
    return function (adId) {
      if (window.lago) {
        var slot = adId ? [window.lago.getAdSlot(adId)] : null;

        window.googletag.cmd.push(function () {
          window.googletag.pubads().refresh(slot);
        });
      }
    };
  },
  displayAdUnit: function displayAdUnit(adId) {
    window.googletag.cmd.push(function () {
      window.googletag.display('' + adId);
    });
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL0V4dGVuc2lvbnMvRGVmYXVsdEV4dGVuc2lvbi5qcyJdLCJuYW1lcyI6WyJtb2R1bGUiLCJleHBvcnRzIiwibmFtZSIsInJlZnJlc2giLCJ3aW5kb3ciLCJsYWdvIiwic2xvdCIsImFkSWQiLCJnZXRBZFNsb3QiLCJnb29nbGV0YWciLCJjbWQiLCJwdXNoIiwicHViYWRzIiwiZGlzcGxheUFkVW5pdCIsImRpc3BsYXkiXSwibWFwcGluZ3MiOiI7O0FBQUFBLE9BQU9DLE9BQVAsR0FBaUI7QUFDZkMsUUFBTSxTQURTO0FBRWZDLFdBQVMsbUJBQU07QUFDYixXQUFPLGdCQUFRO0FBQ2IsVUFBSUMsT0FBT0MsSUFBWCxFQUFpQjtBQUNmLFlBQU1DLE9BQVFDLElBQUQsR0FBUyxDQUFDSCxPQUFPQyxJQUFQLENBQVlHLFNBQVosQ0FBc0JELElBQXRCLENBQUQsQ0FBVCxHQUF5QyxJQUF0RDs7QUFFQUgsZUFBT0ssU0FBUCxDQUFpQkMsR0FBakIsQ0FBcUJDLElBQXJCLENBQTBCLFlBQU07QUFBRVAsaUJBQU9LLFNBQVAsQ0FBaUJHLE1BQWpCLEdBQTBCVCxPQUExQixDQUFrQ0csSUFBbEM7QUFBMEMsU0FBNUU7QUFDRDtBQUNGLEtBTkQ7QUFPRCxHQVZjO0FBV2ZPLGlCQUFlLDZCQUFRO0FBQ3JCVCxXQUFPSyxTQUFQLENBQWlCQyxHQUFqQixDQUFxQkMsSUFBckIsQ0FBMEIsWUFBTTtBQUM5QlAsYUFBT0ssU0FBUCxDQUFpQkssT0FBakIsTUFBNEJQLElBQTVCO0FBQ0QsS0FGRDtBQUdEO0FBZmMsQ0FBakIiLCJmaWxlIjoiRGVmYXVsdEV4dGVuc2lvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbIm1vZHVsZS5leHBvcnRzID0ge1xuICBuYW1lOiAnRGVmYXVsdCcsXG4gIHJlZnJlc2g6ICgpID0+IHtcbiAgICByZXR1cm4gYWRJZCA9PiB7XG4gICAgICBpZiAod2luZG93LmxhZ28pIHtcbiAgICAgICAgY29uc3Qgc2xvdCA9IChhZElkKSA/IFt3aW5kb3cubGFnby5nZXRBZFNsb3QoYWRJZCldIDogbnVsbDtcblxuICAgICAgICB3aW5kb3cuZ29vZ2xldGFnLmNtZC5wdXNoKCgpID0+IHsgd2luZG93Lmdvb2dsZXRhZy5wdWJhZHMoKS5yZWZyZXNoKHNsb3QpOyB9KTtcbiAgICAgIH1cbiAgICB9O1xuICB9LFxuICBkaXNwbGF5QWRVbml0OiBhZElkID0+IHtcbiAgICB3aW5kb3cuZ29vZ2xldGFnLmNtZC5wdXNoKCgpID0+IHtcbiAgICAgIHdpbmRvdy5nb29nbGV0YWcuZGlzcGxheShgJHthZElkfWApO1xuICAgIH0pO1xuICB9XG59O1xuIl19


//////////////////
// WEBPACK FOOTER
// ./node_modules/legacy-advertising/dist/Extensions/DefaultExtension.js
// module id = 594
// module chunks = 0